<!--
 * @Descripttion: 我发起申请列表
 * @Author: jschen
 * @Date: 2021-09-05 14:28:12
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-10-13 15:06:32
-->
<template>
    <div v-show="visible" class="right-box">
        <div class="search-container">
            <div class="search-row">
                <div class="title-item">
                    <span>标题</span>
                    <el-input
                        v-model="searchFlowOpt.title"
                        placeholder="标题关键字搜索"
                        prefix-icon="el-icon-search"
                        size="small"
                    >
                    </el-input>
                </div>
                <div class="date-item">
                    <span>流程状态</span>
                    <el-select
                        v-model="searchFlowOpt.status"
                        placeholder="流程状态"
                        size="small"
                        clearable
                        style="width: 110px;"
                    >
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </div>
                <div class="date-item">
                    <span>创建时间</span>
                    <div class="block">
                        <el-date-picker
                            v-model="searchFlowOpt.date"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            @change="datePicker"
                        >
                        </el-date-picker>
                    </div>
                </div>

                <div class="search-btn-group">
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                    <el-button size="small" @click="reset">重置</el-button>
                </div>
            </div>
        </div>
        <div class="sort-box">
            <div class="sort-title">
                <span>{{ title }}列表</span>
            </div>
            <div class="search-right-box">
                <div class="sort-right-box">
                    <el-button plain size="mini" @click="refresh">刷新</el-button>
                </div>
            </div>
        </div>
        <el-table
            v-loading="loading"
            :data="flowRecords"
            size="mini"
            border
            style="width: 100%"
            height="calc(100% - 145px)"
            @row-click="rowFlowClick"
        >
            <el-table-column label="序号" width="55" align="center">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column min-width="450" label="标题" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span
                        ><span :class="levelStyle(scope.row.alarmLevel)">[{{ levelStatus(scope.row.alarmLevel) }}]</span
                        >{{ scope.row.title }}</span
                    >
                </template>
            </el-table-column>
            <el-table-column prop="createTime" sortable label="创建时间" width="150" align="center">
                <template slot-scope="scope">
                    <span>{{ format(scope.row.createTime) | dateFilter }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="currentApprovers"
                label="当前处理人"
                align="center"
                width="100"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="processTime"
                label="流程处理用时"
                align="center"
                width="150"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span class="process-color">{{ formatRelayDate(scope.row) }}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="approvalUsername" label="当前审批人"> </el-table-column> -->
            <!-- <el-table-column prop="statusText" label="审核状态" align="center">
                <template slot-scope="scope">
                    <span class="process-color">{{ scope.row.statusText }}</span>
                </template>
            </el-table-column> -->
            <el-table-column prop="statusDesc" label="流程状态" align="center">
                <template slot-scope="scope">
                    <span class="process-color">{{ scope.row.statusText }}</span>
                </template>
            </el-table-column>
            <div slot="empty" class="empty">
                <img src="@/assets/pics/no-empty.png" />
                <span>暂无内容</span>
            </div>
        </el-table>
        <div class="pagination-box">
            <el-pagination
                :current-page="searchFlowOpt.current"
                :page-sizes="[20, 50]"
                :page-size="searchFlowOpt.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchFlowOpt.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { getFlows } from "@/api";
import { formatDate, formatProcessTime } from "@/libs/mUtils";
import _ from "lodash";
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            flowRecords: [],
            searchFlowOpt: {
                title: "", // 标题
                date: "",
                current: 1,
                size: 20,
                total: 0,
                status: "",
            },

            statusList: [
                {
                    label: "草稿",
                    value: 1,
                },
                {
                    label: "待审",
                    value: 2,
                },
                {
                    label: "驳回",
                    value: 3,
                },
                {
                    label: "废弃",
                    value: 4,
                },
                {
                    label: "结束",
                    value: 5,
                },
            ],
        };
    },
    computed: {
        levelStatus() {
            return function(status) {
                let level = parseInt(status);
                let levelName = "一般";
                switch (level) {
                    case 1:
                        levelName = "紧急";
                        break;
                    case 2:
                        levelName = "重要";
                        break;
                    default:
                        levelName = "一般";
                        break;
                }
                return levelName;
            };
        },
        levelStyle() {
            return function(level) {
                return `level${level}`;
            };
        },
    },
    methods: {
        formatRelayDate(date) {
            const { createTime, finishTime = "" } = date;
            // if (this.searchAppOpt.taskType === 1) {
            //     return formatProcessTime(createDate, "耗时", finishTime);
            // } else {
            //     if ([0, 1].includes(this.searchAppOpt.handleType)) {
            //         return formatProcessTime(createDate);
            //     } else {
            //         return formatProcessTime(createDate, "耗时", finishTime);
            //     }
            // }
            if (formatProcessTime(createTime, "耗时", finishTime) === "耗时0秒") {
                return "耗时5秒";
            }
            return formatProcessTime(createTime, "耗时", finishTime);
        },
        search() {
            this.searchFlowOpt.current = 1;
            this.loadData();
        },
        loadData() {
            this.queryFlows();
        },
        // 查询已申请列表
        async queryFlows() {
            this.loading = true;
            try {
                const { body, code, message } = await getFlows({
                    ..._.omit(this.searchFlowOpt, ["date", "total"]),
                });
                if (code === "0000") {
                    const { current, records, total } = body;
                    this.flowRecords = records;
                    this.searchFlowOpt.total = total;
                    this.searchFlowOpt.current = current;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        // 刷新
        refresh() {
            this.reset();
        },
        clearKw() {
            this.searchFlowOpt = {
                title: "", // 标题
                date: "",
                current: 1,
                size: 20,
                total: 0,
                status: "",
            };
        },
        reset() {
            this.searchFlowOpt = {
                title: "", // 标题
                date: "",
                current: 1,
                size: 20,
                total: 0,
                status: "",
            };
            this.loadData();
        },
        datePicker(dateArr) {
            const [startDate, endDate] = dateArr;
            this.searchFlowOpt.startDate = startDate ? `${startDate} 00:00:00` : "";
            this.searchFlowOpt.endDate = endDate ? `${endDate} 23:59:59` : "";
        },
        format(nS, str) {
            return formatDate(nS, str);
        },
        rowFlowClick({ url }) {
            window.open(url);
        },
        handleSizeChange(val) {
            this.searchFlowOpt.current = 1;
            this.searchFlowOpt.size = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.searchFlowOpt.current = val;
            this.loadData();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
.level1 {
    color: #e23b50;
}
.level2 {
    color: #c39148;
}
.level3 {
    color: #3a9d80;
}
</style>
